import styled, { css } from 'styled-components';

export const ScActionsMobile = styled.div`
  width: 100%;
  height: 100%;

  & > div {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    .scroll-block__inner {
      overflow: auto;
      padding: 32px 16px 0;

      & > *:not(:last-child) {
        margin-bottom: 32px;
      }
    }

    .jackpot-banner-wrapper {
      margin-top: 32px;
    }
  }
`;

export const ScPanelFooter = styled.footer<{ isAuthenticated: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;

  & > * {
    height: 40px;
  }

  & > div {
    max-width: 100%;
    margin-right: 8px;

    button {
      height: 32px;
    }
  }

  & > a {
    margin-left: auto;

    & > button {
      min-width: 0;
    }

    ${({ isAuthenticated }) =>
      !isAuthenticated &&
      css`
        width: 100%;

        & > button {
          width: 100%;
        }
      `}
  }
`;

export const ScAddToFavoritesBtnContent = styled.div<{ isFavorite: boolean }>`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  color: ${({ theme, isFavorite }) =>
    isFavorite ? theme.secondaryColor : theme.whiteColor};

  .icon__wrapper {
    margin-right: 14px;
    position: relative;
    width: 20px;
    height: auto;

    i {
      display: block;
    }

    .heart-full {
      font-size: 19px;
      color: ${({ theme }) => theme.secondaryColor};
    }
  }
`;

export const ScHomeLink = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .home-icon {
    margin-right: 10px;
    font-size: 17px;
    object-fit: contain;
  }

  @media (max-width: 400px) {
    span {
      font-size: 90%;
    }

    .home-icon {
      margin-right: 4px;
    }
  }

  @media (max-width: 350px) {
    span {
      display: none;
    }

    .home-icon {
      margin-right: 0;
    }
  }
`;
